import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import {
    faGithubAlt,
    faGoogle,
    faFacebook,
    faTwitter
} from '@fortawesome/free-brands-svg-icons';
import { faCheckSquare, faClock } from '@fortawesome/free-solid-svg-icons';

library.add(
    fab,
    faCheckSquare,
    faClock,
    faGithubAlt,
    faGoogle,
    faFacebook,
    faTwitter
);